import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useParams, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from "react";

// Admin panel imports
import AdminLogin from "./pages/AdminLogin";
import Dashboard from "./pages/Dashboard";
import CategoriesPage from "./pages/CategoriesPage";
import ProductsPage from "./pages/ProductsPage";
import BannersPage from "./pages/BannersPage";
import BlogsPage from "./pages/BlogsPage";
import ShippingPage from "./pages/ShippingPage";
import VariantPage from "./pages/VariantPage";
import WalletPage from "./pages/WalletPage";
import OrdersPage from "./pages/OrdersPage";
import SubAdminsPage from "./pages/SubAdminsPage";
import AdminHome from "./pages/AdminHome";
import UserManagement from "./pages/UserManagement";
import AdminSubCategoryPage from "./pages/SubCategoryPage";
import SettingsPage from "./pages/SettingsPage";
import ContactManagement from "./pages/ContactManagement";

import "./App.css";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

// Admin Protected Route
function AdminProtectedRoute({ children }) {
  const adminToken = localStorage.getItem("adminToken");
  if (!adminToken) return <Navigate to="/admin/login" />;
  return children;
}

function App() {
  const VariantPageWrapper = () => {
    const { productId } = useParams();
    return <VariantPage productId={productId} />;
  };

  const SubCategoryPageWrapper = () => {
    const { categoryId } = useParams();
    return <AdminSubCategoryPage categoryId={categoryId} />;
  };

  // Helper for root redirect
  const RootRedirect = () => {
    const adminToken = localStorage.getItem("adminToken");
    return adminToken ? <Navigate to="/adminDashboard" /> : <Navigate to="/admin/login" />;
  };

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* Default redirect to login or dashboard based on auth */}
        <Route path="/" element={<RootRedirect />} />

        <Route path="/admin/login" element={<AdminLogin />} />

        <Route path="/adminDashboard" element={
          <AdminProtectedRoute>
            <Dashboard />
          </AdminProtectedRoute>
        }>
          <Route index element={<AdminHome />} />
          <Route path="users" element={<UserManagement />} />
          <Route path="products" element={<ProductsPage />} />
          <Route path="variant" element={<VariantPage />} />
          <Route path="variant/:productId" element={<VariantPageWrapper />} />
          <Route path="categories" element={<CategoriesPage />} />
          <Route path="banners" element={<BannersPage />} />
          <Route path="wallet" element={<WalletPage />} />
          <Route path="blogs" element={<BlogsPage />} />
          <Route path="shipping-fees" element={<ShippingPage />} />
          <Route path="order" element={<OrdersPage />} />
          <Route path="subadmins" element={<SubAdminsPage />} />
          <Route path="contacts" element={<ContactManagement />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="subcategories" element={<AdminSubCategoryPage />} />
          <Route path="subcategories/:categoryId" element={<SubCategoryPageWrapper />} />
        </Route>

        {/* Fallback for any unknown routes */}
        <Route path="*" element={<RootRedirect />} />
      </Routes>

      <ToastContainer position="top-right" autoClose={1500} style={{ zIndex: 9999999 }} />
    </Router>
  );
}

export default App;
